// AddJobsCard
import React, { useEffect, useState } from 'react'
import BasicDetails from './BasicDetails';
import TeamInfo from './TeamInfo';
import PaymentStructure from './PaymentStructure';
import { connect } from 'react-redux';
import { GetClientDirectoryListPayloadType } from '../../../commonTypes/clientDirectoryTypes';
import { GetAllFinacUserPayloadType } from '../../../commonTypes/authTypes';
import { GetJobsListTypePayload, SingleJobTypePayload } from '../../../commonTypes/jobsType';
import { getAllFinacGovtOfficerAction, getAllFinacManagerAction, getAllFinacPartnerAction, getAllFinacUsersAction, resetFinacManagerList, resetFinacPartnerList, resetFinacUsersList, resetTotalManagerCount } from '../../../redux/auth';
import { getClientDirectoryListAction } from '../../../redux/clientDirectory';
import { getJobsTypeListAction, getRecurringResponsiblePeopleAction, getSingleJobsTypeAction, getRecurringJobsDetailsAction, resetRecurringResponsiblePeople, resetSingleJobs, resetSingleJobsType, resetRecurringJobsDetailsList} from '../../../redux/jobs';
import { RootState } from '../../../redux/rootReducers';
import { ClientDirectoryListType } from '../../../redux/clientDirectory/clientDirectoryType';
import useDebounce from '../../../customHooks/useDebounce';
import { LoginResponseType } from '../../../redux/auth/authTypes';
import moment from 'moment';

type AppProps = {
    jobsData: any;
    jobsError?: any;
    handleChange: (data: any, name: string) => void;
    handleSubmit: () => void;
    history: any;
    type?: string;
    token: string | null;
    success: number | null;
    fetching: boolean;
    error: string | null | undefined;
    message: string;
    statusCode: number | null;
    finacUser: any;
    jobsTypeList: any;
    loginData:LoginResponseType;
    finacManagerList: any;
    finacPartnerList: any;
    finacGovtOfficerList: any;
    totalPartnerCount: string | number;
    userFetching: boolean;
    managerFetching: boolean;
    partnerFetching: boolean;
    OfficerFetching: boolean;
    setJobsData: any;
    setJobsError: any;
    totalJobsTypeCount: number;
    clientFetching: boolean;
    totalManagerCount: string | number;
    totalGovtOfficerCount: string | number;
    clientDirectoryList: [] | ClientDirectoryListType[];
    totalCount: number | null;
    singleJobsType: any;
    singlejobsData?:any;
    resetData:any;
    handleCancel?:()=> void;
    singleRecurringJobsDetails: any;
    recurringResponsiblePeople:any;
    dispatchResetSingleJobs:()=>void;
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => void;
    dispatchGetAllJobsTypeListAction: (data: GetJobsListTypePayload) => void;
    dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllFinacPartnerAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllFinacGovtOfficerAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
    dispatchGetSingleJobType: (data: SingleJobTypePayload) => void;
    dispatchGetRecurringJobsDetailsAction:(data:any)=>void;
    dispatchResetSingleRecurringJobsDetailsAction: ()=>void;
    dispatchGetRecurringResponsiblePeopleAction: (data: any) => void,
    dispatchResetRecurringResponsiblePeopleAction: () => void,
    dispatchResetSingleJobsType: () => void;
    startDateError:string,
    setStateDateError:(data:any)=>void;
}

const AddJobsCard = ({ jobsData,
    setJobsData,
    setJobsError,
    token,
    handleChange,
    userFetching,
    loginData,
    resetData,
    fetching,
    totalJobsTypeCount,
    clientFetching,
    singlejobsData,
    dispatchGetAllFinacManagerAction,
    dispatchGetAllFinacUsersAction,
    dispatchGetAllFinacPartnerAction,
    dispatchGetAllFinacGovtOfficerAction,
    dispatchGetClientDirectoryListAction,
    dispatchGetRecurringJobsDetailsAction,
    dispatchResetSingleRecurringJobsDetailsAction,
    dispatchGetRecurringResponsiblePeopleAction,
    dispatchResetRecurringResponsiblePeopleAction,
    dispatchGetSingleJobType,
    dispatchResetSingleJobsType,
    recurringResponsiblePeople,
    singleJobsType,
    dispatchResetSingleJobs,
    singleRecurringJobsDetails,
    finacManagerList,
    finacPartnerList,
    finacGovtOfficerList,
    OfficerFetching,
    clientDirectoryList,
    totalCount,
    totalManagerCount,
    totalPartnerCount,
    totalGovtOfficerCount,
    partnerFetching,
    managerFetching,
    jobsTypeList,
    finacUser,
    jobsError,
    handleCancel,
    handleSubmit,
    history,
    dispatchGetAllJobsTypeListAction,
    type,
    startDateError,
    setStateDateError
}: AppProps) => {
    const [limit, setLimit] = useState<number>(20);
    const [offset, setoffset] = useState<number>(0);
    const [clientOffset, setClientOffset] = useState<number>(0);
    const [clientLimit, setClientLimit] = useState<number>(20);
    const [clientText, setClientText] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [finalJobTypeList, setFinalJobTypeList] = useState<any>([]);
    const [jobTypeOffset, setJobTypeOffset] = useState<number>(0);
    const [jobTypeText, setJobTypeText] = useState<string>("");
    const [jobTypeLimit, setJobTypeLimit] = useState<number>(20);
    const [finalManagerList, setFinalManagerList] = useState<any>([]);
    const [finalPartnerList, setFinalPartnerList] = useState<any>([])
    const [finalClientList, setFinalClientList] = useState<any>([]);
    const [managerText, setManagerText] = useState<string>("");
    const [managerLimit, setManagerLimit] = useState<number>(20);
    const [managerOffset, setManagerOffset] = useState<number>(0);
    const [partnerText, setPartnerText] = useState<string>("");
    const [partnerLimit, setPartnerLimit] = useState<number>(20);
    const [partnerOffset, setPartnerOffset] = useState<number>(0);
    const [finalUserList, setFinalUserList] = useState<any>([]);
    const [recurringData,setReccurringData]=useState<any>({});
    const [govtOffset, setGovtOffset] = useState<number>(0);
    const [govtLimit, setGovtLimit] = useState<number>(20);
    const [govtText, setGovtText] = useState<string>("");
    const [finalGovtOfficerList, setFinalGovtOfficerList] = useState<any>([]);

    const checkBottom = () => {
        setoffset((prv: any) => prv + limit);
    };

    const checkClientBottom = () => {
        setClientOffset((prv: any) => prv + clientLimit);
    };

    const checkManagerBottom = () => {
        setManagerOffset((prv: any) => prv + managerLimit);
    };

    const checkPartnerBottom = () => {
        setPartnerOffset((prv: any) => prv + partnerLimit);
    };

    const checkJobTypeBottom = () => {
        setJobTypeOffset((prv: any) => prv + jobTypeLimit);
    };

    const checkGovtBottom = () => {
        setGovtOffset((prv: any) => prv + govtLimit);
    };


    useEffect(()=>{
        setReccurringData({})
        // dispatchResetSingleJobs()
        dispatchResetSingleJobsType()
        dispatchResetRecurringResponsiblePeopleAction()
        dispatchResetSingleRecurringJobsDetailsAction()
    },[])
  

    useEffect(() => {
        if (jobsData?.jobType?.value) {
            setReccurringData({})
            dispatchResetSingleJobsType()
            setStateDateError && setStateDateError("")
            dispatchGetSingleJobType({ token, id: jobsData?.jobType?.value })
        }
    }, [jobsData?.jobType?.value])

    useEffect(()=>{
        if(jobsData?.jobType?.value && jobsData?.client?.value && token){

            let finalData={
                token,
                job_type:jobsData?.jobType?.value,
                client_code:jobsData?.client?.value
            }

            dispatchGetRecurringResponsiblePeopleAction(finalData)
        }
    },[jobsData?.jobType?.value,jobsData?.client?.value])

    useEffect(()=>{
   if(recurringResponsiblePeople?.length>0 && type!="editJobCard"){
    let {manager,responsible,govt_officer}=recurringResponsiblePeople[0]
    if(manager?.user_id){
        setJobsError((prev:any)=>{
            return{
                ...prev,
                jobManager:""
            }
        })
    }
    if(responsible?.user_id){
        setJobsError((prev:any)=>{
            return{
                ...prev,
                currResponsible:""
            }
        })
    }
    setJobsData((prev:any)=>({
     ...prev,
     jobManager:{value:manager?.user_id,label:manager?.first_name+ " " + manager?.last_name},
     currResponsible:{value:responsible?.user_id,label:responsible?.first_name+ " " + responsible?.last_name},
     govtOfficer: {value: govt_officer?.user_id, label: govt_officer?.user_id ? (govt_officer?.first_name+ " " + govt_officer?.last_name) : ""}

    }))
   }
    },[recurringResponsiblePeople])

    useEffect(() => {
        if(type!="editJobCard"){
            dispatchResetSingleRecurringJobsDetailsAction()
            let {manager,responsible,govt_officer}=recurringResponsiblePeople?.length>0 && recurringResponsiblePeople[0];

            if(manager?.user_id && responsible?.user_id){
                setJobsData((prev:any)=>({
                    ...prev,
                    currResponsible: {value:responsible.user_id,label:responsible?.first_name+ " " + responsible.last_name},
                    jobManager: {value:manager.user_id,label:manager?.first_name+ " " + manager.last_name},
                   }))
            }
            else{
                setJobsData((prev:any)=>({
                    ...prev,
                    periodEnded: "",
                    targetStartDate: "",
                    targetEndDate: "",
                    jobDesc: "",
                    currResponsible: { value: "", label: "" },
                    jobPartner: { value: "", label: "" },
                    jobManager: { value: "", label: "" },
                    govtOfficer: { value: "", label: ""},
                   }))
            }
           

            if(singleJobsType?._id){
                setReccurringData({...singleJobsType})
            }
            if (singleJobsType?.is_recurring === true) {

                setJobsData((prev: any) => ({
                    ...prev,
                    jobDesc: singleJobsType?.job_details,
                    targetStartDate:singleJobsType?.recurring_job_settings?.target_start_date?.date,
                    targetEndDate:singleJobsType?.recurring_job_settings?.target_end_date?.date,
                    periodEnded:singleJobsType?.recurring_job_settings?.next_period_end_date ? moment(singleJobsType?.recurring_job_settings?.next_job_start_date).subtract(1,"days").format("DD-MM-YYYY") : ""
                }))
                if(singleJobsType?.recurring_job_settings?.next_period_end_date){
                    setJobsError((prev:any)=>{
                    return{
                        ...prev,
                        periodEnded:""
                    }
                })}
            }
            else if (singleJobsType?.is_recurring === false) {
                setJobsData((prev: any) => ({
                    ...prev,
                    jobDesc: singleJobsType?.job_details
                }))
            }
        }
    }, [singleJobsType,recurringResponsiblePeople])

    useEffect(() => {
        if(type!="editJobCard"){
            dispatchResetSingleRecurringJobsDetailsAction()
            if (jobsData?.client?.value && token) {
                const finalData = {
                    token,
                    clientCode: jobsData?.client?.value
                }
                dispatchGetRecurringJobsDetailsAction(finalData)
            }
        }
    }, [jobsData?.client?.value])


    //jobs type
    useEffect(() => {

        if (token) {
            let finalUserData = {
                token,
                offset: jobTypeOffset,
                limit: jobTypeLimit,
                search_term: jobTypeText,
                // recurring:1
            };
            if (jobTypeOffset <= totalJobsTypeCount) {
                dispatchGetAllJobsTypeListAction(finalUserData)
            }
        }
    }, [jobTypeOffset])


    useEffect(() => {
        const jobTypeListData = jobsTypeList?.map((data: any) => {
            return {
                value: data?._id,
                label: data?.job_type  
            }
        })
        if (jobTypeOffset > 0) {
            setFinalJobTypeList([...finalJobTypeList, ...jobTypeListData])
        } else {
            setFinalJobTypeList(jobTypeListData)
        }
    }, [jobsTypeList])

    const fetchJobTypeNewData = (search: string) => {
        const finalData = {
            token,
            offset: jobTypeOffset,
            limit: jobTypeLimit,
            search_term: jobTypeText,
            // recurring: 0
        }
        dispatchGetAllJobsTypeListAction(finalData)
    }

    useDebounce(() => {
        if (jobTypeText) {
            fetchJobTypeNewData(jobTypeText)
        }
        else {
            const finalData = {
                token,
                offset: jobTypeOffset,
                limit: jobTypeLimit,
                search_term: jobTypeText,
                // recurring: 0
            }
            dispatchGetAllJobsTypeListAction(finalData)
        }
    }, 500, [jobTypeText]);

    //finacManager
    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset: managerOffset,
                limit: managerLimit,
                user_type: 'manager',
                status: 1,
                search_term: managerText,
            };
            if (managerOffset <= +totalManagerCount) {
                dispatchGetAllFinacManagerAction(finalUserData)
            }
        }
    }, [managerOffset])

    useEffect(() => {
        const finalManagerData = finacManagerList?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (managerOffset > 0) {
            setFinalManagerList([...finalManagerList, ...finalManagerData]);
        } else {
            setFinalManagerList(finalManagerData);
        }
    }, [finacManagerList])

    const fetchNewManagerData = (search: string) => {
        const finalData = {
            token,
            offset: managerOffset,
            limit: managerLimit,
            user_type: 'manager',
            status: 1,
            search_term: managerText,
        }
        dispatchGetAllFinacManagerAction(finalData)
    }

    useDebounce(() => {
        if (managerText) {
            fetchNewManagerData(managerText)
        }
        else {
            const finalData = {
                token,
                offset: managerOffset,
                limit: managerLimit,
                user_type: 'manager',
                status: 1,
                search_term: managerText,
            }
            dispatchGetAllFinacManagerAction(finalData)
        }
    }, 500, [managerText]);

    //Finac Partner List


    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset: partnerOffset,
                limit: partnerLimit,
                user_type: 'partner',
                status: 1,
                search_term: partnerText,
            };
            if (partnerOffset <= +totalPartnerCount) {
                dispatchGetAllFinacPartnerAction(finalUserData)
            }
        }
    }, [partnerOffset])

    useEffect(() => {
        if (token) {
            const finalData = {
                token,
                offset: govtOffset,
                limit: govtLimit,
                user_type: 'govt_officer',
                status: 1,
                search_term: govtText,
            };
            if (govtOffset <= +totalGovtOfficerCount) {
                dispatchGetAllFinacGovtOfficerAction(finalData)
            }
        }
    }, [govtOffset])

    const fetchNewGovtOfficerData = (search: string) => {
        const finalData = {
            token,
            offset: govtOffset,
            limit: govtLimit,
            user_type: 'govt_officer',
            status: 1,
            search_term: govtText,
        }
        dispatchGetAllFinacGovtOfficerAction(finalData)
    }

    useDebounce(() => {
        if(govtText) {
            fetchNewGovtOfficerData(govtText)
        }
        else{
            const finalData = {
                token,
                offset: govtOffset,
                limit: govtLimit,
                user_type: 'govt_officer',
                status: 1,
                search_term: govtText,                
            }
            dispatchGetAllFinacGovtOfficerAction(finalData)
        }
    }, 500, [govtText]);

    useEffect(() => {
        const finalGovtOfficerData = finacGovtOfficerList?.map((user: any) => {
            return {
                value: user?.user_id,
                label:`${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (govtOffset > 0) {
            setFinalGovtOfficerList([...finalGovtOfficerList, ...finalGovtOfficerData]);
        } else {
            setFinalGovtOfficerList(finalGovtOfficerData)
        }
    }, [finacGovtOfficerList])

    useEffect(() => {
        const finalPartnerData = finacPartnerList?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (partnerOffset > 0) {
            setFinalPartnerList([...finalPartnerList, ...finalPartnerData]);
        } else {
            setFinalPartnerList(finalPartnerData);
        }
    }, [finacPartnerList])

    const fetchNewPartnerData = (search: string) => {
        const finalData = {
            token,
            offset: partnerOffset,
            limit: partnerLimit,
            user_type: 'partner',
            status: 1,
            search_term: partnerText,
        }
        dispatchGetAllFinacPartnerAction(finalData)
    }

    useDebounce(() => {
        if (partnerText) {
            fetchNewPartnerData(partnerText)
        }
        else {
            const finalData = {
                token,
                offset: partnerOffset,
                limit: partnerLimit,
                user_type: 'partner',
                status: 1,
                search_term: partnerText,
            }
            dispatchGetAllFinacPartnerAction(finalData)
        }
    }, 500, [partnerText]);


    //Finac User List
    useEffect(() => {
        const finalUserData = finacUser?.data?.map((user: any) => {
            return {
                value: user?.user_id,
                label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""} `,
                image: user?.profile_pic?.file_url
            };
        })
        if (offset > 0) {
            setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
            setFinalUserList(finalUserData);
        }
    }, [finacUser])


    useEffect(() => {
        if (token) {
            let finalUserData = {
                token,
                offset,
                limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            };
            if (offset <= finacUser?.total_count) {
                dispatchGetAllFinacUsersAction(finalUserData)
            }
        }
    }, [offset])

    const fetchNewData = (search: string) => {
        const finalData = {
            token,
            offset,
            limit,
            user_type: 'stco_users',
            status: 1,
            search_term: text,
        }
        dispatchGetAllFinacUsersAction(finalData)
    }

    useDebounce(() => {
        if (text) {
            fetchNewData(text)
        }
        else {
            const finalData = {
                token,
                offset,
                limit,
                user_type: 'stco_users',
                status: 1,
                search_term: text,
            }
            dispatchGetAllFinacUsersAction(finalData)
        }
    }, 500, [text]);

    //clientDirectoryList

    useEffect(() => {
        const finalClientListData = clientDirectoryList?.map((data: any) => {
            return {
                value: data?.client_code,
                label: `${data?.company_name}(${data?.client_code})`
            }
        })
        if (clientOffset > 0) {
            setFinalClientList([...finalClientList, ...finalClientListData])
        }
        else {
            setFinalClientList(finalClientListData)
        }
    }, [clientDirectoryList])


    useEffect(() => {
        if (token && totalCount) {
            if (clientOffset <= +totalCount) {
                const finalData = {
                    token,
                    status: 1,
                    offset: clientOffset,
                    limit: clientLimit,
                    searchValue: clientText,
                }
                dispatchGetClientDirectoryListAction(finalData)
            }
        }
    }, [clientOffset])

    const fetchClientNewData = () => {
        const finalData = {
            token,
            status: 1,
            offset: clientOffset,
            limit: clientLimit,
            searchValue: clientText,
        }
        dispatchGetClientDirectoryListAction(finalData)
    }

    useDebounce(() => {
        if (clientText) {
            fetchClientNewData()
        }
        else {
            const finalData = {
                token,
                status: 1,
                offset: clientOffset,
                limit: clientLimit,
                searchValue: clientText,
            }
            dispatchGetClientDirectoryListAction(finalData)
        }
    }, 500, [clientText])


    return (
        <div>

            <div className="recurring-job-setting">Basic Details</div>
            <BasicDetails
               recurringData={recurringData}
                setJobTypeOffset={setJobTypeOffset}
                setJobTypeText={setJobTypeText}
                fetching={fetching}
                checkJobTypeBottom={checkJobTypeBottom}
                setoffset={setoffset}
                userFetching={userFetching}
                checkBottom={checkBottom}
                checkClientBottom={checkClientBottom}
                setClientOffset={setClientOffset}
                clientFetching={clientFetching}
                setClientText={setClientText}
                setText={setText}
                jobsError={jobsError}
                jobsData={jobsData}
                handleChange={handleChange}
                finalClientList={finalClientList}
                finalJobTypeList={finalJobTypeList}
                singleJobsType={singleJobsType}
                singlejobsData={singlejobsData}
                type={type}
                startDateError={startDateError}
                loginData={loginData}
            />

            <div className="recurring-job-setting">Team Info</div>
            <TeamInfo
                recurringData={recurringData}
                setoffset={setoffset}
                userFetching={userFetching}
                checkBottom={checkBottom}
                setText={setText}
                jobsData={jobsData}
                handleChange={handleChange}
                finalManagerList={finalManagerList}
                finalUserList={finalUserList}
                finalPartnerList={finalPartnerList}
                managerFetching={managerFetching}
                setManagerOffset={setManagerOffset}
                checkManagerBottom={checkManagerBottom}
                setManagerText={setManagerText}
                partnerFetching={partnerFetching}
                setPartnerOffset={setPartnerOffset}
                checkPartnerBottom={checkPartnerBottom}
                setPartnerText={setPartnerText}
                recurringResponsiblePeople={recurringResponsiblePeople}
                type={type}
                jobsError={jobsError}
                singlejobsData={singlejobsData}
                loginData={loginData}
                checkGovtBottom={checkGovtBottom}
                OfficerFetching={OfficerFetching}
                setGovtOffset={setGovtOffset}
                setGovtText={setGovtText}
                finalGovtOfficerList={finalGovtOfficerList}
            />

            <div className="recurring-job-setting">Payment Structure</div>
            <PaymentStructure
                jobsData={jobsData}
                handleChange={handleChange}
                singlejobsData={singlejobsData}
                loginData={loginData}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10%" }}>
                <button className='btn btn-outline' onClick={()=>type=="editJobCard" ? handleCancel && handleCancel() :history?.push({pathname:"/jobs/jobs-list",state:{}})}>Cancel</button>
                <button className='btn btn-primary' disabled={fetching} onClick={handleSubmit}>{type == "editJobCard" ? "Save Changes" : "Save"}</button>
            </div>

        </div>
    )
}

const mapStateTopProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.jobs.fetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    clientFetching: state.clientDirectory.fetching,
    message: state.jobs.message,
    jobsTypeList: state.jobs.jobsTypeList,
    finacUser: state.auth.finacUsersList,
    loginData:state.auth.loginData,
    userFetching: state.auth.fetching,
    partnerFetching: state.auth.partnerFetching,
    managerFetching: state.auth.managerFetching,
    finacManagerList: state.auth.finacManagerList,
    finacPartnerList: state.auth.finacPartnerList,
    totalPartnerCount: state.auth.totalPartnerCount,
    totalManagerCount: state.auth.totalManagerCount,
    OfficerFetching: state.auth.gotvOfficerFetching,
    finacGovtOfficerList: state.auth.finacGovtOfficerList,
    totalGovtOfficerCount: state.auth.totalGovtOfficerCount,
    totalJobsTypeCount: state.jobs.jobsTypeListTotalCount,
    totalCount: state.clientDirectory.totalCount,
    singleJobsType: state.jobs.singleJobsType,
    singleRecurringJobsDetails: state.jobs.singleRecurringJobsDetails,
    clientDirectoryList: state.clientDirectory.clientDirectoryList,
    recurringResponsiblePeople:state.jobs.recurringResponsiblePeople
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => dispatch(getClientDirectoryListAction(data)),
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
    dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacManagerAction(data)),
    dispatchGetAllFinacPartnerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacPartnerAction(data)),
    dispatchGetAllFinacGovtOfficerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacGovtOfficerAction(data)),
    dispatchGetAllJobsTypeListAction: (data: GetJobsListTypePayload) => dispatch(getJobsTypeListAction(data)),
    dispatchGetSingleJobType: (data: SingleJobTypePayload) => dispatch(getSingleJobsTypeAction(data)),
    dispatchGetRecurringJobsDetailsAction: (data: any) => dispatch(getRecurringJobsDetailsAction(data)),
    dispatchResetSingleRecurringJobsDetailsAction: ()=> dispatch(resetRecurringJobsDetailsList()),
    dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
    dispatchResetFinacPartnerList: () => dispatch(resetFinacPartnerList()),
    dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
    dispatchResetTotalManagerCount: () => dispatch(resetTotalManagerCount()),
    dispatchGetRecurringResponsiblePeopleAction: (data: any) => dispatch(getRecurringResponsiblePeopleAction(data)),
    dispatchResetRecurringResponsiblePeopleAction: () => dispatch(resetRecurringResponsiblePeople()),
    dispatchResetSingleJobs:()=>dispatch(resetSingleJobs()),
    dispatchResetSingleJobsType : ()=> dispatch(resetSingleJobsType())
})

export default connect(mapStateTopProps, mapDispatchToProps)(AddJobsCard)